<template>
  <div>
    <TilteParallax>
      <template v-slot:title> Cliente </template>

      <template v-slot:subtitle v-if="customer">
        {{ `${customer.folio} - ${customer.name}` }}
      </template>

      <template v-slot:menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="default" fab v-bind="attrs" v-on="on" elevation="5">
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="ui.edit = true" v-if="!ui.edit">
              <v-list-item-title> Editar </v-list-item-title>
            </v-list-item>

            <v-list-item @click="editCancel()" v-if="ui.edit">
              <v-list-item-title> Cancelar edición </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </TilteParallax>

    <v-container fluid>
      <v-row justify="center" class="pt-0 mt-0">
        <v-col cols="12" md="10">
          <v-card outlined :loading="ui.geting" :disabled="ui.updating">
            <v-card-text class="pt-0">
              <v-row v-if="customer">
                <v-col cols="12">
                  <v-tabs v-model="ui.tab">
                    <v-tab>
                      <v-icon left> mdi-card-text-outline </v-icon>
                      General
                    </v-tab>

                    <v-tab>
                      {{ `Pedidos(${SalesOrdes.length})` }}
                    </v-tab>

                    <v-tab v-if="customer.user">
                      <v-icon left> mdi-account-outline </v-icon>
                      Usuario
                    </v-tab>
                    <!-- <v-tab>
                      {{ `Articulos ( ${allArticles.length} )` }}
                    </v-tab> -->
                  </v-tabs>

                  <v-tabs-items v-model="ui.tab">
                    <!-- Datos generales -->
                    <v-tab-item>
                      <v-container>
                        <v-form
                          ref="formGeneralData"
                          v-model="ui.forms.generalData"
                          lazy-validation
                          @submit.prevent="generalDataUpdate()"
                        >
                          <v-row>
                            <v-col cols="12">
                              <template v-if="!ui.edit">
                                <v-row>
                                  <v-col cols="12" md="4" class="d-flex flex-column">
                                    <strong>Folio:</strong>
                                    {{ customer.folio }}
                                  </v-col>
                                  <v-col cols="12" md="4" class="d-flex flex-column">
                                    <strong>Nombre:</strong>
                                    {{ customer.name }}
                                  </v-col>

                                  <v-col cols="12" md="4" class="d-flex flex-column">
                                    <strong>RFC:</strong>
                                    {{ customer.rfc }}
                                  </v-col>
                                  <v-col cols="12" md="4" class="d-flex flex-column">
                                    <strong> Descuento: </strong>
                                    {{ `${customer.discount}%` }}
                                  </v-col>

                                  <v-col cols="12" md="4" class="d-flex flex-column">
                                    <strong> Lista de precios: </strong>

                                    <template v-if="customer.price_list">
                                      <router-link
                                        :to="{
                                          name: 'PriceListShow',
                                          params: {
                                            id: customer.price_list.id,
                                          },
                                        }"
                                      >
                                        {{ customer.price_list.name }}
                                      </router-link>
                                    </template>
                                  </v-col>
                                </v-row>
                              </template>

                              <template v-else>
                                <v-row>
                                  <v-col cols="12" md="4">
                                    <v-text-field
                                      :rules="[v.required]"
                                      dense
                                      outlined
                                      clearable
                                      label="Folio"
                                      v-model="customer.folio"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <v-text-field
                                      :rules="[v.required]"
                                      dense
                                      outlined
                                      clearable
                                      label="Nombre"
                                      v-model="customer.name"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" md="4">
                                    <v-text-field
                                      :rules="[v.required, v.rfc]"
                                      dense
                                      outlined
                                      clearable
                                      label="RFC"
                                      v-model="customer.rfc"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <v-text-field
                                      :rules="[
                                        v.required,
                                        v.min(Number, 0, customer.discount),
                                        v.max(Number, 100, customer.discount),
                                      ]"
                                      dense
                                      outlined
                                      clearable
                                      label="Descuento(%)"
                                      type="numeric"
                                      v-model="customer.discount"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" md="4">
                                    <v-overflow-btn
                                      dense
                                      editable
                                      outlined
                                      clearable
                                      autocomplete="off"
                                      label="Lista de precios"
                                      :rules="[v.required]"
                                      :items="Pricelists"
                                      v-model="customer.price_list_id"
                                    >
                                    </v-overflow-btn>
                                  </v-col>

                                  <v-col cols="12" class="d-flex justify-end pt-0 pb-0">
                                    <v-btn
                                      text
                                      @click="editCancel()"
                                      color="primary"
                                      class="mr-2"
                                      :disabled="ui.updating"
                                    >
                                      cancelar
                                    </v-btn>

                                    <v-btn
                                      class="primary"
                                      :disabled="!ui.forms.generalData || ui.canceling"
                                      :loading="ui.updating"
                                      @click="generalDataUpdate()"
                                    >
                                      guardar
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-tab-item>

                    <!-- Ordenes de venta -->
                    <v-tab-item>
                      <v-container>
                        <v-data-table :headers="headers" :items="SalesOrdes">
                          <!-- Discount Slot -->
                          <template v-slot:item.discount="{ item }">
                            {{ `${item.discount}%` }}
                          </template>

                          <!-- Slot Created_at -->
                          <template v-slot:item.created_at="{ item }">
                            <ChipCreatedAt
                              :date="item.created_at_raw"
                              :format="'YYYY-MM-DD HH:mm:ss'"
                            />
                          </template>

                          <!-- Slot Status -->
                          <template v-slot:item.status="{ item }">
                            <chip-status :status="item.status" small />
                          </template>

                          <!-- Slot Exported_at -->
                          <template v-slot:item.exported_at="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <span color="primary" dark v-bind="attrs" v-on="on">
                                  {{ item.exported_at_for_humans }}
                                </span>
                              </template>
                              <span>
                                {{ item.exported_at }}
                              </span>
                            </v-tooltip>
                          </template>

                          <!-- Actions Slot -->
                          <template v-slot:item.actions="{ item }">
                            <strong>
                              <router-link
                                :to="{
                                  name: 'SalesOrderShow',
                                  params: {
                                    id: item.id,
                                  },
                                }"
                              >
                                Ver
                              </router-link>
                            </strong>
                          </template>
                        </v-data-table>
                      </v-container>
                    </v-tab-item>

                    <!-- Usuario -->
                    <v-tab-item v-if="customer.user">
                      <v-container>
                        <template v-if="!ui.edit">
                          <v-row>
                            <v-col
                              cols="12"
                              md="4"
                              class="d-flex flex-column"
                              v-if="customer.user"
                            >
                              <strong> Correo electrónico: </strong>
                              {{ customer.user.email }}
                            </v-col>

                            <v-col cols="12" md="4" class="d-flex flex-column">
                              <strong> Status: </strong>
                              {{ customer.user.active ? "Activo" : "Inactivo" }}
                            </v-col>
                          </v-row>
                        </template>

                        <template v-else>
                          <v-form
                            ref="formUser"
                            v-model="ui.forms.formUser"
                            lazy-validation
                            @submit.prevent="userUpdate()"
                          >
                            <v-row>
                              <v-col cols="12" md="4" v-if="customer.user">
                                <v-text-field
                                  :rules="[v.required, v.email]"
                                  dense
                                  outlined
                                  clearable
                                  label="Correo electrónico"
                                  v-model="customer.user.email"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" md="4">
                                <v-switch
                                  class="mt-1"
                                  v-model="customer.user.active"
                                  inset
                                  :label="customer.user.active ? 'Activo' : 'Inactivo'"
                                ></v-switch>
                              </v-col>

                              <v-col cols="12" class="d-flex justify-end pt-0 pb-0">
                                <v-btn
                                  text
                                  @click="editCancel()"
                                  color="primary"
                                  class="mr-2"
                                  :disabled="ui.userUpdating"
                                >
                                  cancelar
                                </v-btn>

                                <v-btn
                                  @click="userUpdate()"
                                  color="primary"
                                  :disabled="!ui.forms.formUser || ui.canceling"
                                  :loading="ui.userUpdating"
                                >
                                  guardar
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </template>
                      </v-container>
                    </v-tab-item>
                    <!-- Articles -->
                    <!-- <v-tab-item>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-btn
                              class="col-12"
                              color="primary"
                              @click="sendArticles()"
                              :disabled="!ui.valid"
                              :loading="ui.loading"
                            >
                              GUARDAR
                            </v-btn>
                          </v-col>
                          <v-col cols="12" class="pb-0">
                            <v-text-field
                              dense
                              outlined
                              label="Críterio de busqueda"
                              v-model="ui.filters.criterium"
                              clearable
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="mb-3">
                            <v-data-table
                              show-select
                              item-key="id"
                              :items="Results"
                              v-model="allArticles"
                              :search="ui.filters.criterium"
                              :headers="headerArticles"
                            ></v-data-table>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-tab-item> -->
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/main";
import TilteParallax from "@/components/TilteParallax";
import { mapState } from "vuex";
import { V } from "@/main";

// Components
import ChipCreatedAt from "@/../../GeneralComponents/ChipCreatedAt";
import ChipStatus from "@/components/SalesOrder/ChipStatus";

export default {
  components: { TilteParallax, ChipCreatedAt, ChipStatus },

  data() {
    return {
      v: V,

      data: {
        price_lists: [],
        pricelists: [],
      },

      layout: {
        allArticles: [],
      },

      allArticles: [],
      articles: null,
      customer: null,

      criterium: null,

      ui: {
        tab: 0,
        valid: true,
        loading: false,
        edit: false,

        checkerLoading: false,
        typeAction: "create",

        geting: true,
        updating: false,
        canceling: false,
        userUpdating: false,
        pricelistsGeting: false,
        articles: false,
        typeAction: "create",
        filters: {
          criterium: null,
        },
        forms: {
          formUser: true,
          generalData: true,
        },
      },

      headers: [
        { text: "ID", value: "id" },
        { text: "Usuario", value: "user.email" },
        { text: "Metodo de envío", value: "shipping_method.name" },
        { text: "Fecha de creación", value: "created_at_new" },
        { text: "Status", value: "status" },
        { text: "Ultima exportación", value: "exported_at" },
        // { text: "Descuento (%)", value: "discount" },
        { text: "Acciones", value: "actions" },
      ],

      headerArticles: [
        { text: "id", value: "id" },
        { text: "Codigo", value: "code" },
        { text: "Descripción", value: "description" },
        { text: "Producto", value: "product.name" },
        { text: "Acabado", value: "type_of_finish.name" },
        { text: "Precio base", value: "base_price" },
        { text: "Descuento base(%)", value: "base_discount" },
        { text: "Contenido neto", value: "contents" },
        { text: "UM", value: "unit_of_measurement.name" },
        { text: "Peso", value: "weight" },
        { text: "Capacidad por caja", value: "box_capacity" },
      ],
    };
  },

  created() {
    this.get();

    this.getPriceList();

    if (this.$route.query.criterium) {
      this.ui.filters.criterium = this.$route.query.criterium;
    }
  },

  methods: {
    async get() {
      try {
        this.ui.geting = true;
        let resp = await axios.get(
          `${process.env.VUE_APP_API_SERVER}/auth/store/customer/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.acount.token}`,
            },
          }
        );
        // let getarticles = await axios.get(
        //   `${process.env.VUE_APP_API_SERVER}/auth/store/article/all/withtrashed`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${this.acount.token}`,
        //     },
        //   }
        // );
        // this.articles = getarticles.data.data;
        this.customer = resp.data.data;
        // let articles = this.customer.assigned_articles.map((item) => item.article_id);
        // this.allArticles = this.articles.filter((item) => articles.includes(item.id));
      } catch (error) {
        EventBus.$emit("Error", { error: error, errorsShow: true });
      } finally {
        this.ui.geting = false;
      }
    },

    async getPriceList() {
      try {
        this.ui.pricelistsGeting = true;

        let response = await axios.get(
          `${process.env.VUE_APP_API_SERVER}/auth/pricelist`,
          {
            headers: {
              Authorization: `Bearer ${this.acount.token}`,
            },
          }
        );
        this.data.pricelists = response.data.data;
      } catch (error) {
        EventBus.$emit("Error", { error: error, errorsShow: true });
      } finally {
        this.ui.pricelistsGeting = false;
      }
    },

    async generalDataUpdate() {
      if (
        confirm(`¿Quieres actualizar este registro?`) &&
        this.$refs.formGeneralData.validate()
      ) {
        try {
          this.ui.updating = true;

          let resp = await axios.put(
            `${process.env.VUE_APP_API_SERVER}/auth/store/customer/${this.$route.params.id}`,
            {
              ...this.customer,
              price_list_id: this.customer.price_list_id
                ? this.customer.price_list_id
                : null,
            },
            {
              headers: {
                Authorization: `Bearer ${this.acount.token}`,
              },
            }
          );

          await this.get();

          this.ui.edit = false;

          EventBus.$emit("Snackbar", {
            text: "Registroactualizado.",
            type: "success",
            timeout: 2000,
          });
        } catch (error) {
          EventBus.$emit("Error", { error: error, errorsShow: true });
        } finally {
          this.ui.updating = false;
        }
      }
    },

    async userUpdate() {
      if (
        confirm(`¿Quieres actualizar este registro?`) &&
        this.$refs.formUser.validate()
      ) {
        try {
          this.ui.userUpdating = true;

          let resp = await axios.put(
            `${process.env.VUE_APP_API_SERVER}/auth/store/user/${
              this.customer.user ? this.customer.user.id : undefined
            }`,
            this.customer.user,
            {
              headers: {
                Authorization: `Bearer ${this.acount.token}`,
              },
            }
          );

          await this.get();

          this.ui.edit = false;

          EventBus.$emit("Snackbar", {
            text: "Registroactualizado.",
            type: "success",
            timeout: 2000,
          });
        } catch (error) {
          EventBus.$emit("Error", { error: error, errorsShow: true });
        } finally {
          this.ui.userUpdating = false;
        }
      }
    },

    async editCancel() {
      this.ui.canceling = true;

      await this.get();

      this.ui.edit = false;

      this.ui.canceling = false;
    },

    // Articles
    async updateArticles() {
      try {
        if (this.$refs.formGeneralData.validate()) {
          let articles = this.mappingArticles();
          let resp = await axios.put(
            `${process.env.VUE_APP_API_SERVER}/auth/store/article/${this.customer.id}/refresh`,
            {articles: articles['allArticles']},
            {
              headers: {
                Authorization: `Bearer ${this.acount.token}`,
              },
            }
          );
        }
      } catch (error) {
        throw error;
      }
    },
    mappingArticles() {
      return {
        ...this.layout,
        allArticles: this.allArticles.map((item) => item.id),
      };
    },
    async sendArticles() {
      try {
        if (this.$refs.formGeneralData.validate()) {
          if (!this.allArticles.length) {
            return EventBus.$emit("Error", {
              error: "¡Atención!",
              subtitle: "Antes de continuar.",
              message: "Debe seleccionar al menos un articulo para poder continuar.",
              alertShow: true,
            });
          }
          this.ui.loading = true;
          await this.updateArticles();
          await this.get();
          EventBus.$emit("Snackbar", {
            text: "Actualizado correctamente",
            type: "success",
          });
        }
      } catch (error) {
        EventBus.$emit("Error", { error: error, errorsShow: true });
      } finally {
        this.ui.loading = false;
      }
    },
  },

  computed: {
    ...mapState(["acount"]),
    Pricelists() {
      return this.data.pricelists.map((item) => {
        return {
          text: item.name,
          value: item.id,
        };
      });
    },
    Results() {
      let results = this.articles;
      return results;
    },
    SalesOrdes() {
      return this.customer.sales_orders.reverse();
    },
  },
};
</script>

<style lang="css" scoped></style>
